import users from './users';
import orders from './orders';
import subscriptions from './subscriptions';
import dripFeed from './drip-feed';
import refill from './refill';
import cancel from './cancel';
import services from './services';
import payments from './payments';
import tickets from './tickets';
import newYear from './new-year';
import affiliates from './affiliates';
import childPanels from './child-panels';
import updates from './updates';
import reports from './reports';
import appearance from './appearance';
import settings from './settings';
import account from './account';
import user from './user';
import super_admin from './superadmin';
import guides from './guides';

export const defaultRoutesArray = [
  ...users,
  ...orders,
  ...subscriptions,
  ...dripFeed,
  ...refill,
  ...cancel,
  ...services,
  ...payments,
  ...tickets,
  ...newYear,
  ...affiliates,
  ...childPanels,
  ...updates,
  ...reports,
  ...appearance,
  ...settings,
  ...account,
  ...user,
  ...super_admin,
  ...guides,
];

export const allRoutes = defaultRoutesArray.reduce((accumulator, currentValue) => {
  accumulator.push({
    ...currentValue,
    secondaryLinks: [],
  });
  if (currentValue?.secondaryLinks?.length) {
    currentValue?.secondaryLinks.forEach((url) => {
      accumulator.push({
        ...currentValue,
        link: url,
        secondaryLinks: [],
      })
    })
  }
  return accumulator;
}, [])
